export const dataSetTopFeed = [
    {
        rank: "1",
        production: "28,175",
        company: "CP Group",
        country: "Thailand",
        feed: "",
    },
    {
        rank: "2",
        production: "28,000",
        company: "New Hope Group",
        country: "China",
        feed: "200",
    },
    {
        rank: "3",
        production: "19,630",
        company: "Haid Group",
        country: "China",
        feed: "",
    },
    {
        rank: "4",
        production: "19,600",
        company: "Cargill",
        country: "United States",
        feed: "39",
    },
    {
        rank: "5",
        production: "13,500",
        company: "Land O'Lakes",
        country: "United States",
        feed: "",
    },
    {
        rank: "6",
        production: "13,110",
        company: "Muyuan Foodstuff",
        country: "China",
        feed: "",
    },
    {
        rank: "7",
        production: "11,000",
        company: "JBS S.A.",
        country: "Brazil",
        feed: "49",
    },
    {
        rank: "8",
        production: "11,000",
        company: "Shuangbootai Group",
        country: "China",
        feed: "",
    },
    {
        rank: "9",
        production: "10,071",
        company: "BRF",
        country: "Brazil",
        feed: "27",
    },
    {
        rank: "10",
        production: "10,000",
        company: "ForFarmers N.V.",
        country: "Netherlands",
        feed: "35",
    },
    {
        rank: "10",
        production: "10,000",
        company: "Tyson Foods",
        country: "United States",
        feed: "32",
    },
    {
        rank: "10",
        production: "10,000",
        company: "Wen's Food Group",
        country: "China",
        feed: "",
    },
    {
        rank: "13",
        production: "240",
        company: "202",
        country: "84%",
        feed: "202",
    },
    {
        rank: "14",
        production: "210",
        company: "187",
        country: "89%",
        feed: "127",
    },
    {
        rank: "15",
        production: "96",
        company: "86",
        country: "89%",
        feed: "11",
    },
];